import { Util } from './vue/master.js'

const shopList = [
  // {
  //   shop_id: 1,
  //   name: 'ホンダドリームジャパン',
  //   leader: '',
  //   mail: 'Daisuke_Suzuki@honda-dream.com',
  // },
  {
    shop_id: 677,
    name: 'ホンダドリーム 豊橋',
    leader: 'akihisa_adachi@honda-dream.com',
    mail: 'info_toyohashi@honda-dream.com',
  },
  {
    shop_id: 672,
    name: 'ホンダドリーム 福岡西',
    leader: 'Takeyuki_Hasegawa@honda-dream.com',
    mail: 'info_fukuokanishi@honda-dream.com',
  },
  {
    shop_id: 667,
    name: 'ホンダドリーム 福岡春日',
    leader: 'Takeyuki_Hasegawa@honda-dream.com',
    mail: 'info_fukuokakasuga@honda-dream.com',
  },
  {
    shop_id: 663,
    name: 'ホンダドリーム 久留米',
    leader: 'Takeyuki_Hasegawa@honda-dream.com',
    mail: 'info_kurume@honda-dream.com',
  },
  {
    shop_id: 659,
    name: 'ホンダドリーム 福岡東',
    leader: 'Takeyuki_Hasegawa@honda-dream.com',
    mail: 'info_fukuokahigashi@honda-dream.com',
  },
  {
    shop_id: 652,
    name: 'ホンダドリーム 博多',
    leader: 'Takeyuki_Hasegawa@honda-dream.com',
    mail: 'info_hakata@honda-dream.com',
  },
  {
    shop_id: 638,
    name: 'ホンダドリーム 熊本',
    leader: 'Takeyuki_Hasegawa@honda-dream.com',
    mail: 'info_kumamoto@honda-dream.com',
  },
  {
    shop_id: 634,
    name: 'ホンダドリーム 徳島',
    leader: 'Kazuyuki_Maemura@honda-dream.com',
    mail: 'info_tokushima@honda-dream.com',
  },
  {
    shop_id: 630,
    name: 'ホンダドリーム 高知',
    leader: 'Kazuyuki_Maemura@honda-dream.com',
    mail: 'info_kochi@honda-dream.com',
  },
  {
    shop_id: 626,
    name: 'ホンダドリーム 岡山',
    leader: 'Kazuyuki_Maemura@honda-dream.com',
    mail: 'info_okayama@honda-dream.com',
  },
  {
    shop_id: 622,
    name: 'ホンダドリーム 高松',
    leader: 'Kazuyuki_Maemura@honda-dream.com',
    mail: 'info_takamatsu@honda-dream.com',
  },
  {
    shop_id: 618,
    name: 'ホンダドリーム 福山',
    leader: 'Kazuyuki_Maemura@honda-dream.com',
    mail: 'info_fukuyama@honda-dream.com',
  },
  {
    shop_id: 614,
    name: 'ホンダドリーム 広島',
    leader: 'Kazuyuki_Maemura@honda-dream.com',
    mail: 'info_hiroshima@honda-dream.com',
  },
  {
    shop_id: 610,
    name: 'ホンダドリーム 姫路',
    leader: 'toru_hasegawa@honda-dream.com',
    mail: 'info_dhimeji@honda-dream.com',
  },
  {
    shop_id: 3480,
    name: 'ホンダドリーム 西宮甲子園',
    leader: 'toru_hasegawa@honda-dream.com',
    mail: 'info_nishinomiyakoshien@honda-dream.com',
  },
  {
    shop_id: 606,
    name: 'ホンダドリーム 京都北山',
    leader: 'toru_hasegawa@honda-dream.com',
    mail: 'info_kyotokitayama@honda-dream.com',
  },
  {
    shop_id: 602,
    name: 'ホンダドリーム 京都右京',
    leader: 'toru_hasegawa@honda-dream.com',
    mail: 'info_kyotoukyo@honda-dream.com',
  },
  {
    shop_id: 598,
    name: 'ホンダドリーム 豊中',
    leader: 'toru_hasegawa@honda-dream.com',
    mail: 'info_toyonaka@honda-dream.com',
  },
  {
    shop_id: 593,
    name: 'ホンダドリーム 東淀川',
    leader: 'toru_hasegawa@honda-dream.com',
    mail: 'info_higashiyodogawa@honda-dream.com',
  },
  {
    shop_id: 587,
    name: 'ホンダドリーム 尼崎',
    leader: 'toru_hasegawa@honda-dream.com',
    mail: 'info_amagasaki@honda-dream.com',
  },
  {
    shop_id: 583,
    name: 'ホンダドリーム 京都伏見',
    leader: 'toru_hasegawa@honda-dream.com',
    mail: 'info_kyotofushimi@honda-dream.com',
  },
  {
    shop_id: 579,
    name: 'ホンダドリーム 藤井寺',
    leader: 'toru_hasegawa@honda-dream.com',
    mail: 'info_fujiidera@honda-dream.com',
  },
  {
    shop_id: 575,
    name: 'ホンダドリーム 箕面',
    leader: 'toru_hasegawa@honda-dream.com',
    mail: 'info_mino@honda-dream.com',
  },
  {
    shop_id: 571,
    name: 'ホンダドリーム 神戸灘',
    leader: 'toru_hasegawa@honda-dream.com',
    mail: 'info_kobenada@honda-dream.com',
  },
  {
    shop_id: 567,
    name: 'ホンダドリーム 堺',
    leader: 'toru_hasegawa@honda-dream.com',
    mail: 'info_sakai@honda-dream.com',
  },
  {
    shop_id: 560,
    name: 'ホンダドリーム 奈良',
    leader: 'toru_hasegawa@honda-dream.com',
    mail: 'info_nara@honda-dream.com',
  },
  {
    shop_id: 555,
    name: 'ホンダドリーム 岐阜',
    leader: 'akihisa_adachi@honda-dream.com',
    mail: 'info_gifu@honda-dream.com',
  },
  {
    shop_id: 545,
    name: 'ホンダドリーム 名古屋上小田井',
    leader: 'akihisa_adachi@honda-dream.com',
    mail: 'info_kamiotai@honda-dream.com',
  },
  {
    shop_id: 540,
    name: 'ホンダドリーム 一宮',
    leader: 'akihisa_adachi@honda-dream.com',
    mail: 'info_ichinomiya@honda-dream.com',
  },
  {
    shop_id: 529,
    name: 'ホンダドリーム 名古屋東',
    leader: 'akihisa_adachi@honda-dream.com',
    mail: 'info_nagoyahigashi@honda-dream.com',
  },
  {
    shop_id: 520,
    name: 'ホンダドリーム 小牧',
    leader: 'akihisa_adachi@honda-dream.com',
    mail: 'info_komaki@honda-dream.com',
  },
  {
    shop_id: 515,
    name: 'ホンダドリーム 名古屋南',
    leader: 'akihisa_adachi@honda-dream.com',
    mail: 'info_nagoyaminami@honda-dream.com',
  },
  {
    shop_id: 503,
    name: 'ホンダドリーム 名古屋中央',
    leader: 'akihisa_adachi@honda-dream.com',
    mail: 'info_nagoyachuo@honda-dream.com',
  },
  {
    shop_id: 496,
    name: 'ホンダドリーム川崎宮前',
    leader: 'daisuke_suzuki@honda-dream.com',
    mail: 'info_kawasakimiyamae@honda-dream.com',
  },
  {
    shop_id: 487,
    name: 'ホンダドリーム 横浜緑',
    leader: 'daisuke_suzuki@honda-dream.com',
    mail: 'info_yokohamamidori@honda-dream.com',
  },
  {
    shop_id: 477,
    name: 'ホンダドリーム 横浜旭',
    leader: 'daisuke_suzuki@honda-dream.com',
    mail: 'info_yokohamaasahi@honda-dream.com',
  },
  {
    shop_id: 466,
    name: 'ホンダドリーム 横浜都筑',
    leader: 'daisuke_suzuki@honda-dream.com',
    mail: 'info_yokohamatsuzuki@honda-dream.com',
  },
  {
    shop_id: 461,
    name: 'ホンダドリーム 磯子',
    leader: 'daisuke_suzuki@honda-dream.com',
    mail: 'info_isogo@honda-dream.com',
  },
  {
    shop_id: 448,
    name: 'ホンダドリーム 立川',
    leader: 'daisuke_suzuki@honda-dream.com',
    mail: 'info_tachikawa@honda-dream.com',
    bcc: 'Tomoyuki_nakazawa@honda-dream.com',
  },
  {
    shop_id: 439,
    name: 'ホンダドリーム 大田',
    leader: 'daisuke_suzuki@honda-dream.com',
    mail: 'info_ota@honda-dream.com',
  },
  {
    shop_id: 432,
    name: 'ホンダドリーム 葛飾',
    leader: 'daisuke_suzuki@honda-dream.com',
    mail: 'info_katsushika@honda-dream.com',
  },
  {
    shop_id: 419,
    name: 'ホンダドリーム 板橋',
    leader: 'daisuke_suzuki@honda-dream.com',
    mail: 'info_itabashi@honda-dream.com',
  },
  {
    shop_id: 391,
    name: 'ホンダドリーム 練馬',
    leader: 'daisuke_suzuki@honda-dream.com',
    mail: 'info_nerima@honda-dream.com',
  },
  {
    shop_id: 382,
    name: 'ホンダドリーム 西東京',
    leader: 'daisuke_suzuki@honda-dream.com',
    mail: 'info_nishitokyo@honda-dream.com',
  },
  {
    shop_id: 377,
    name: 'ホンダドリーム 新座',
    leader: 'Shin_yogakiuchi@honda-dream.com',
    mail: 'info_niiza@honda-dream.com',
  },
  {
    shop_id: 370,
    name: 'ホンダドリーム 草加',
    leader: 'Shin_yogakiuchi@honda-dream.com',
    mail: 'info_soka@honda-dream.com',
  },
  {
    shop_id: 366,
    name: 'ホンダドリーム 東浦和',
    leader: 'Shin_yogakiuchi@honda-dream.com',
    mail: 'info_higashiurawa@honda-dream.com',
  },
  {
    shop_id: 361,
    name: 'ホンダドリーム 狭山',
    leader: 'Shin_yogakiuchi@honda-dream.com',
    mail: 'info_sayama@honda-dream.com',
  },
  {
    shop_id: 356,
    name: 'ホンダドリーム 大宮',
    leader: 'Shin_yogakiuchi@honda-dream.com',
    mail: 'info_omiya@honda-dream.com',
  },
  {
    shop_id: 347,
    name: 'ホンダドリーム 所沢',
    leader: 'Shin_yogakiuchi@honda-dream.com',
    mail: 'info_tokorozawa@honda-dream.com',
  },
  {
    shop_id: 338,
    name: 'ホンダドリーム 鴻巣',
    leader: 'Shin_yogakiuchi@honda-dream.com',
    mail: 'info_konosu@honda-dream.com',
  },
  {
    shop_id: 330,
    name: 'ホンダドリーム 蘇我',
    leader: 'hirokazu_kimoto@honda-dream.com',
    mail: 'info_soga@honda-dream.com',
  },
  {
    shop_id: 321,
    name: 'ホンダドリーム 松戸',
    leader: 'hirokazu_kimoto@honda-dream.com',
    mail: 'info_matsudo@honda-dream.com',
  },
  {
    shop_id: 317,
    name: 'ホンダドリーム 船橋',
    leader: 'hirokazu_kimoto@honda-dream.com',
    mail: 'info_funabashi@honda-dream.com',
  },
  {
    shop_id: 312,
    name: 'ホンダドリーム 水戸北',
    leader: 'hirokazu_kimoto@honda-dream.com',
    mail: 'info_mitokita@honda-dream.com',
  },
  {
    shop_id: 308,
    name: 'ホンダドリーム 郡山',
    leader: 'hirokazu_kimoto@honda-dream.com',
    mail: 'info_koriyama@honda-dream.com',
  },
  {
    shop_id: 288,
    name: 'ホンダドリーム 宮城岩沼',
    leader: 'hirokazu_kimoto@honda-dream.com',
    mail: 'info_miyagiiwanuma@honda-dream.com',
  },
  {
    shop_id: 283,
    name: 'ホンダドリーム 仙台泉',
    leader: 'hirokazu_kimoto@honda-dream.com',
    mail: 'info_sendaiizumi@honda-dream.com',
  },
  {
    shop_id: 275,
    name: 'ホンダドリーム 盛岡',
    leader: 'hirokazu_kimoto@honda-dream.com',
    mail: 'info_morioka@honda-dream.com',
  },
  {
    shop_id: 10,
    name: 'ホンダドリーム 世田谷',
    leader: 'daisuke_suzuki@honda-dream.com',
    mail: 'info_setagaya@honda-dream.com',
    bcc: 'Tomoyuki_nakazawa@honda-dream.com',
  },
  {
    shop_id: 244,
    name: 'ホンダドリーム ふかや花園',
    leader: 'Shin_yogakiuchi@honda-dream.com',
    mail: 'info_fukayahanazono@honda-dream.com',
  },
]

const inquiryShopListSet = () => {
  const body = document.querySelector('body')
  const shopSelect = document.querySelector('select[name="fld-shop"]')
  const confirmInquiryType = document.querySelector('[id="confirmInquiryType"]')

  if (shopSelect) {
    const url = new URL(window.location.href)
    const paramsID = Number(url.searchParams.get('shop_id'))
    const paramsText = url.searchParams.get('txt')
    const pdfUrl = url.searchParams.get('pdf')
    const bccInput = document.querySelector('[name="bcc"]')

    const { DEALER } = Util
    // const hdj = document.createElement('option')
    // hdj.setAttribute('data-id', 1)
    // hdj.setAttribute('value', 'Daisuke_Suzuki@honda-dream.com')
    // hdj.innerText = 'ホンダドリームジャパン'
    // shopSelect.appendChild(hdj)

    DEALER.area.forEach((area) => {
      const optgroup = document.createElement('optgroup')
      optgroup.setAttribute('label', area.name)

      area.shops.forEach((shop) => {
        const shopData = shopList.find((data) => data.shop_id === shop.shop_id)
        const option = document.createElement('option')
        option.setAttribute('value', shopData.mail)
        option.setAttribute('data-id', shop.shop_id)

        if (shop.shop_id == '503') {
          option.setAttribute('disabled', true)
          option.innerText = `${shop.name} ※店舗改装の為一時閉店中(’26年4月リニューアルオープン予定)`
        } else {
          option.innerText = shop.name
        }

        if (paramsID === shopData.shop_id) {
          option.setAttribute('selected', true)
          document.querySelector('[name="shop_name"]').value = shopData.name
          document.querySelector('[name="leader"]').value = shopData.leader

          if (pdfUrl && bccInput) {
            bccInput.value = shopData.bcc
          }
        }

        optgroup.appendChild(option)
      })

      shopSelect.appendChild(optgroup)
    })

    shopSelect.addEventListener('change', () => {
      const shopData = shopList.find((data) => data.mail === shopSelect.value)
      document.querySelector('[name="shop_name"]').value = shopData ? shopData.name : ''
      document.querySelector('[name="leader"]').value = shopData ? shopData.leader : ''

      if (pdfUrl && bccInput) {
        bccInput.value = shopData.bcc ? shopData.bcc : ''
      }
    })

    // if (paramsID === 1) {
    //   document.querySelector('input[value="法人向けサービス"]').click()
    //   document.querySelector('[name="fld-shop"]').value = 'Daisuke_Suzuki@honda-dream.com'
    //   document.querySelector('[name="shop_name"]').value = 'ホンダドリームジャパン'
    //   document.querySelector('[name="leader"]').value = 'Daisuke_Suzuki@honda-dream.com'
    // }

    if (paramsText) {
      document.querySelector('[name="fld-message"]').value = `「${paramsText}」に関するお問い合わせ`
    }

    Array.from(document.querySelectorAll('[name="fld-inquiry-type"]')).forEach((input) => {
      input.addEventListener('change', () => {
        if (input.value === '法人向けサービス' && input.checked) {
          body.classList.add('is-corporate-checked')
        } else {
          body.classList.remove('is-corporate-checked')
        }
      })
    })
  }

  if (confirmInquiryType && confirmInquiryType.getAttribute('data-type') === '法人向けサービス') {
    body.classList.add('is-corporate-checked')
  }
}

export { inquiryShopListSet }
